import locale from "localization";

export const expenseType = [
  { label: locale.form2307, value: locale.form2307 },
  { label: locale.water, value: locale.water },
  { label: locale.internet, value: locale.internet },
  { label: locale.electricity, value: locale.electricity },
  { label: locale.electricityGeneratorSet, value: locale.electricityGeneratorSet },
  { label: locale.loadAllowance, value: locale.loadAllowance },
  { label: locale.postage, value: locale.postage },
  { label: locale.transportation, value: locale.transportation },
  { label: locale.officeSupplies, value: locale.officeSupplies },
  { label: locale.photocopy, value: locale.photocopy },
  { label: locale.otherSupplies, value: locale.otherSupplies },
  { label: locale.promoAdvertising, value: locale.promoAdvertising },
  { label: locale.permitsLicensesTaxes, value: locale.permitsLicensesTaxesWithoutComma },
  { label: locale.stationProgramExpense, value: locale.stationProgramExpense },
  { label: locale.maintenanceRepairs, value: locale.maintenanceRepairs },
  { label: locale.mealAllowance, value: locale.mealAllowance },
  { label: locale.bankCharges, value: locale.bankCharges },
  { label: locale.lubesIncentives, value: locale.lubesIncentives },
  { label: locale.accommodation, value: locale.accommodation },
  { label: locale.nonInventoryItemRebates, value: locale.nonInventoryItemRebates },
  { label: locale.nonInventoryItemIndexCard, value: locale.nonInventoryItemIndexCard },
];
